'use strict';

module.exports = {
    config: null
};
